import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5230cb74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-element" }

import Multiselect from '@vueform/multiselect';

import { SortOption } from '@/types/sortOptions';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicSelect',
  props: {
    modelValue: {},
    options: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;





const onSelect = (value: string) => {
  emit('update:modelValue', value)
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Multiselect), {
      value: props.modelValue,
      placeholder: "Без сортировки",
      options: props.options,
      onChange: onSelect
    }, null, 8, ["value", "options"])
  ]))
}
}

})